export interface Icons {
    [key: string]: string;
}

export const ICONS: Icons = {
    'Food & Beverage': 'fa-solid fa-burger',
    'Home Dining': 'fa-solid fa-house-user',
    'Fitness': 'fa-solid fa-person-skating',
    'Pets': 'fa-solid fa-paw',
    'Education': 'fa-solid fa-school',
    'Child Care': 'fa-solid fa-child',
    'Home Improvement': 'fa-solid fa-house-chimney',
    'Beauty & Grooming': 'fa-solid fa-b',
    'Automobile & Transport': 'fa-solid fa-car',
    'Games and Hobbies': 'fa-solid fa-gamepad',
    'Others': 'fa-solid fa-ellipsis',
    'Cleaning': 'fas fa-broom',
    'Technology': 'fas fa-desktop',

    'Plumbing': 'fa-solid fa-wrench',
    'Locksmith': 'fa-solid fa-wrench',
    'Drilling & Handyman': 'fa-solid fa-wrench',
    'Home Cleaner': 'fa-solid fa-wrench',
    'Painter': 'fa-solid fa-wrench',
    'Aircon': 'fa-solid fa-wrench',
    'Electrician': 'fa-solid fa-wrench',

    'Insurance': 'fa-solid fa-house-crack',
    'Unspecified': 'fa-solid fa-house-crack',
    'Outdoor & Camping': 'fa-solid fa-house-crack',

    'Coffee': 'fas fa-coffee',
    'Event Catering': 'fa fa-utensils',
    'Tuition': 'fa fa-university'
}